import { createAsyncThunk } from "@reduxjs/toolkit";

import getUrl from "Libs/getUrl";
import logger from "Libs/logger";

import { getOrganization } from "./getOrganization.thunk";

import type {
  UpdateOrganizationProps,
  UpdateOrganizationFulfilled
} from "../types";
import type { Organization } from "@packages/client";
import type { AsyncThunkOptionType } from "Reducers/types";

export const updateOrganization = createAsyncThunk<
  UpdateOrganizationFulfilled,
  UpdateOrganizationProps,
  AsyncThunkOptionType
>(
  "app/organizations/update_organization",
  async (
    { organizationDescriptionId, organization },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const orgResponse = await dispatch(
        getOrganization({
          organizationDescriptionId
        })
      );
      const organizationToUpdate: Organization =
        orgResponse?.payload?.organization;

      const newOrganization = await organizationToUpdate?.update(
        organization,
        organizationToUpdate.getLink("self")
      );

      const updatedOrganization = organizationToUpdate?.updateLocal(
        newOrganization.data
      );

      if (organization?.name) {
        // Redirect to the new organization name
        const newPath = getUrl({
          key: "organization.settings",
          props: { organizationId: organization.name }
        });

        return { organization: updatedOrganization, redirectTo: newPath };
      }

      return { organization: updatedOrganization };
    } catch (err) {
      logger(err, {
        action: "updateOrganization",
        organizationDescriptionId,
        organization
      });

      return rejectWithValue(err);
    }
  }
);
